import styled, { css } from 'styled-components';
import ArrowDownIcon from '../../../icons/ArrowDown';

const visibleStyles = css`
  padding: 0.5em;
`;

const invisibleStyles = css`
  padding: 0;
  visibility: hidden;
`;

export const DownArrow = styled(ArrowDownIcon)`
  width: 9px;
  height: 10px;
  margin-left: 4px;
`;

export const UpArrow = styled(DownArrow)`
  transform: rotate(180deg);
`;

export const InternalLinkModTitle = styled.h3`
  order: 2;
  color: ${props => props.theme.carvana.blue.dark};
  font-family: 'Brandon Text';
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 18px;
    letter-spacing: 1.8px;
    text-align: center;
  }
`;

export const InternalLinkModWrapper = styled.div`
  width: 100%;
`;

export const InternalLinkModOverview = styled.div`
  background-color: white;
  padding: 52px 0px;
  text-align: center;
`;

export const InternalModLinks = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 90%;
    display: inline-block;
  }
`;

export const ContentSectionBase = styled.div`
  background-color: ${props => (props.whiteBackground ? '#ffffff' : 'auto')};
  padding: 19px 0px;
  order: 1;
  position: relative;
  vertical-align: top;

  & h3 span {
    display: block;
    height: 18px;
    color: ${props => props.theme.carvana.blue.dark};
    font-family: 'Brandon Text';
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: 19px;
    padding-bottom: 1em;
  }
  & h3 {
    color: ${props => props.theme.carvana.gray.dark};
    font-family: 'Brandon Text';
    font-size: 22px;
    font-weight: 300;
  }
`;

export const InternalLinkModArea = styled(ContentSectionBase)`
  order: 3;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    text-align: center;
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
    text-align: left;
    justify-content: start;
  }
  @media (min-width: ${props => props.theme.breakpoints.values.xl}px) {
    justify-content: start;
  }
`;

export const InternalLinkStyle = styled.a`
  color: ${props => props.theme.carvana.blue.primary};
  font-family: 'Brandon Text';
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  text-transform: capitalize;
`;

export const InternalLinkWrapper = styled.div`
  flex-basis: 100%;
  ${props => (props.isVisible ? visibleStyles : invisibleStyles)}

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    text-align: center;
    padding-left: 0px;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
    flex-basis: ${props => (props.isNotDivisibleByThree ? '20%' : '33%')};
    text-align: center;
    padding-left: 0px;
  }
  @media (min-width: ${props => props.theme.breakpoints.values.xl}px) {
    flex-basis: ${props => (props.isNotDivisibleByThree ? '20%' : '33%')};
    text-align: center;
    padding-left: 0px;
  }
`;

export const ViewMoreButton = styled.div`
  order: 5;
  color: ${props => props.theme.carvana.blue.primary};
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 18px;
    letter-spacing: 1.8px;
    text-align: center;
    padding-left: 5%;
    max-width: 95%;
  }
`;
